// Custom storage adapter for Supabase in Electron renderer.
// It mimics Web Storage, but proxies to main via preload-exposed APIs when available.

const hasIpcStorage = typeof window !== 'undefined' && window.auth && window.auth.storage;

function ensureString(value) {
  return typeof value === 'string' ? value : JSON.stringify(value ?? null);
}

export const storageAdapter = {
  getItem(key) {
    try {
      if (hasIpcStorage) return window.auth.storage.getItem(key);
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  },

  setItem(key, value) {
    const str = ensureString(value);
    try {
      if (hasIpcStorage) return window.auth.storage.setItem(key, str);
      localStorage.setItem(key, str);
    } catch (e) {
      // noop
    }
  },

  removeItem(key) {
    try {
      if (hasIpcStorage) return window.auth.storage.removeItem(key);
      localStorage.removeItem(key);
    } catch (e) {
      // noop
    }
  },

  clear() {
    try {
      if (hasIpcStorage) return window.auth.storage.clear();
    } catch (e) {
      // noop
    }
  },
};


